import http from "@/utils/request";

const declare = {
  queryDeclareOrderList: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.queryDeclareOrderList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  list: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.queryForDeclareOrders",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  detail: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.queryDeclareOrderDetail",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  restApply: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.restApply",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  restPort: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.restPort",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  restTpl: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.restTpl",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  reWms: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.reWms",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  reMailNo: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.reSendMailNoToMerchant",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  tagNoNeedLowDeclare: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.tagAsNoNeedLowDeclareByBizId",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  downloadDeclareList: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.submitDeclareOrderBuildExcelTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  submitCustomsDeclareOrderBuildExcelTask: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.submitCustomsDeclareOrderBuildExcelTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  updateBusinessState: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.updateBusinessState",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  updateStockoutOrderInfo: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.updateStockoutOrderInfo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  updatePddOrderInfo: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.updatePddOrderInfo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  updateStcokoutOrderSku: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.updateStcokoutOrderSku",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  auditStockoutOrder(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.auditStockoutOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  systemRunInfo(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.systemRunInfo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  uploadNuclearNoteExcel(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.previewNuclareMailNoImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  submitNuclareBuildExcelTask(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.submitNuclareBuildExcelTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  submitCustomsDeclareOrderDetailTask(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.submitCustomsDeclareOrderDetailTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  orderSplitByAccountBook(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.orderSplitByAccountBook",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  reSendNotifyMessage(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.reSendNotifyMessage",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  previewDeclareOrderImport(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.previewDeclareOrderImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  batchImportDeclareOrder(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.importDeclareOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  cancelStockout(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.cancelStockout",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  cancelOrder(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.cancelOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  modifyCarrier(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.modifyCarrier",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  cancelOrderByMerchantOrderNo(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.cancelOrderByMerchantOrderNo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  orderActionRecordPageQuery(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.orderActionRecordPageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
  syncAccountBookStock(data) {
    return http.sendRequest({
      METHOD_NAME: "customsDeclare.syncAccountBookStock",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  },
};

export default declare;
